import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { H1, Sub } from "./_shared";

export default function AuditSection() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="cp-audit">
      <H1>Audit log</H1>
      <Sub>Every admin mutation, newest first.</Sub>
      <div className="mt-6 pp-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-wider text-zinc-500 bg-white/5"><tr>
            <th className="text-start px-4 py-3">When</th>
            <th className="text-start px-4 py-3">Actor</th>
            <th className="text-start px-4 py-3">Action</th>
            <th className="text-start px-4 py-3">Target</th>
            <th className="text-start px-4 py-3">Details</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-white/5" data-testid={`cp-audit-row-${r.id}`}>
                <td className="px-4 py-2 text-zinc-500 text-xs whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                <td className="px-4 py-2 text-xs">{r.actor?.email || r.actor_id?.slice(0, 8)}</td>
                <td className="px-4 py-2"><span className="pp-chip">{r.action}</span></td>
                <td className="px-4 py-2 font-mono text-xs">{r.target_type}{r.target_id ? `:${r.target_id.slice(0, 8)}` : ""}</td>
                <td className="px-4 py-2 text-xs text-zinc-400 font-mono">{r.details && Object.keys(r.details).length ? JSON.stringify(r.details) : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="text-center text-zinc-500 py-10">No actions yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
